import { useCallback, useEffect, useMemo } from 'react';

import { useBylineTracking } from '../AssetMetadata/useBylineTracking';

import type { MouseEventHandler, VFC } from 'react';
import type { CnpAuthor } from '@vgtv/api-client/lib/cnp_authors';

interface BylineProps {
  author: CnpAuthor;
}

export const Byline: VFC<BylineProps> = ({ author }) => {
  const getAssetBylines = (author: CnpAuthor) => {
    const { contacts, title } = author;
    const email = contacts?.find((contact) => contact.type === 'email')?.value;

    return {
      title,
      email,
    };
  };

  const { title, email } = useMemo(() => getAssetBylines(author), [author]);
  const { trackBylineClick, trackBylineView } = useBylineTracking(title);

  useEffect(() => {
    trackBylineView();
  }, [trackBylineView]);

  const handleClick: MouseEventHandler<HTMLAnchorElement> = useCallback(() => {
    trackBylineClick();
  }, [trackBylineClick]);

  return (
    <a
      href={email ? `mailto:${email}` : undefined}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      {title}
    </a>
  );
};
